import { TREE_ACTIONS, TreeNode } from '@ali-hm/angular-tree-component'
import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { GlobalMessageType } from '@spartacus/core'
import { Observable, of } from 'rxjs'
import { catchError, finalize } from 'rxjs/operators'
import { AccountSummaryService } from '../../../services/account/account-summary.service'
import { CustomGlobalMessageService } from '../../../services/shared/custom-global-message/custom-global-message.service'

@Component({
    selector: 'app-account-summary-details',
    templateUrl: './account-summary-details.component.html',
    styleUrls: ['./account-summary-details.component.scss'],
    standalone: false
})
export class AccountSummaryDetailsComponent implements OnInit {
  public orgUnits: any[]
  public showLoader = true
  public orgUnitDetail$: Observable<any>
  public showLoaderDetail: boolean
  public showTree = true
  public showDetail = false
  public selectedNode: TreeNode

  constructor(
    private accountSummaryService: AccountSummaryService,
    private changeDetectorRef: ChangeDetectorRef,
    public globalMessageService: CustomGlobalMessageService
  ) {}

  ngOnInit(): void {
    this.accountSummaryService
      .getOrgUnits()
      .pipe(
        finalize(() => {
          this.showLoader = false
          this.changeDetectorRef.detectChanges()
        })
      )
      .subscribe(
        (res) => {
          if (res) {
            this.orgUnits = [res]
          }
        },
        (err) => {
          this.globalMessageService.add(err.message, GlobalMessageType.MSG_TYPE_ERROR)
        }
      )
  }

  public toggleNode(node: TreeNode, eve): void {
    TREE_ACTIONS.TOGGLE_EXPANDED(node.treeModel, node, eve)
  }

  public showOrgUnitDetail(node: TreeNode): void {
    this.selectedNode = node
    this.showHideDetail(true)
    this.getOrgUnitDetail(node.data.id)
  }

  private getOrgUnitDetail(value: string): void {
    this.showLoaderDetail = true
    this.orgUnitDetail$ = this.accountSummaryService.getOrgUnitDetail(value).pipe(
      finalize(() => {
        this.showLoaderDetail = false
      }),
      catchError((err) => {
        this.globalMessageService.add(err.message, GlobalMessageType.MSG_TYPE_ERROR)
        return of(null)
      })
    )
  }

  public showHideDetail(showDetail: boolean): void {
    this.showTree = !showDetail
    this.showDetail = showDetail
  }

  public highlightActiveNode(node: TreeNode): boolean {
    return this.selectedNode === node
  }
}
